import {
  numberToChar93r9buh19yek as numberToChar,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  StringBuildermazzzhj6kkai as StringBuilder,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  charArray2ujmm1qusno00 as charArray,
  concatToString2syawgu50khxi as concatToString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  maxOrNull2lr3mpfpypi46 as maxOrNull,
  Char__plus_impl_qi7pgj1h8009bm3fa2t as Char__plus_impl_qi7pgj,
  Char19o2r8palgjof as Char,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  fill3lmv1pckd4inv as fill,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  ArrayList3it5z8td81qkl as ArrayList,
  coerceIn10f36k81le1mm as coerceIn,
  substringiqarkczpya5m as substring,
  Regexxgw0gjiagf4z as Regex,
  lazy2hsh8ze7j6ikd as lazy,
  copyOf3rutauicler23 as copyOf,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  contentEquals2jbsaphs7gxql as contentEquals,
  startsWith1bgirhbedtv2y as startsWith,
  endsWith278181ii8uuo as endsWith,
  toString336ienavfnzn0 as toString_0,
  toInt5qdj874w69jh as toInt,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  substringBefore3n7kj60w69hju as substringBefore,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  coerceAtMost322komnqp70ag as coerceAtMost,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  lb4(_this__u8e3s4, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) || codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__u8e3s4.o1(numberToChar(55296 | hs));
      _this__u8e3s4.o1(numberToChar(56320 | ls));
    } else {
      _this__u8e3s4.o1(numberToChar(codePoint));
    }
  }
}
class Charset {
  constructor(name) {
    this.mb4_1 = name;
  }
  nb4(nbytes) {
    return imul(nbytes, 2);
  }
}
class BaseSingleByteCharset extends Charset {
  nb4(nbytes) {
    return nbytes;
  }
}
class SingleByteCharset extends BaseSingleByteCharset {
  constructor(name, conv) {
    super(name);
    this.qb4_1 = conv;
    var tmp = this;
    var tmp5_safe_receiver = maxOrNull(this.qb4_1);
    var tmp_0;
    var tmp_1 = tmp5_safe_receiver;
    if ((tmp_1 == null ? null : new Char(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Char__plus_impl_qi7pgj(tmp5_safe_receiver, 1);
    }
    var tmp6_safe_receiver = tmp_0;
    var tmp_2;
    var tmp_3 = tmp6_safe_receiver;
    if ((tmp_3 == null ? null : new Char(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.code' call
      tmp_2 = Char__toInt_impl_vasixd(tmp6_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp_2;
    tmp.rb4_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_4 = this;
    // Inline function 'kotlin.also' call
    var this_0 = new Int8Array(this.rb4_1);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(63);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
    fill(this_0, toByte(tmp$ret$3));
    var inductionVariable = 0;
    var last = charSequenceLength(this.qb4_1) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_2 = charCodeAt(this.qb4_1, n);
        this_0[Char__toInt_impl_vasixd(this_2)] = toByte(n);
      }
       while (inductionVariable <= last);
    tmp_4.sb4_1 = this_0;
  }
  ob4(out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.o1(charCodeAt(this.qb4_1, src[n] & 255));
      }
       while (inductionVariable < end);
    return end - start | 0;
  }
}
class ISO_8859_1 extends SingleByteCharset {
  constructor() {
    ISO_8859_1_instance = null;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.o1(numberToChar(n));
      }
       while (inductionVariable < 256);
    super('ISO-8859-1', this_0.toString());
    ISO_8859_1_instance = this;
  }
}
class Charsets {
  ub4() {
    return get_LATIN1();
  }
}
class UTF16Charset extends Charset {
  constructor(le) {
    super('UTF-16-' + (le ? 'LE' : 'BE'));
    this.wb4_1 = le;
  }
  nb4(nbytes) {
    return imul(nbytes, 2);
  }
  ob4(out, src, start, end) {
    var consumed = 0;
    var progression = step(until(start, end), 2);
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(getS16(src, n, this.wb4_1));
        out.o1(char);
        consumed = consumed + 2 | 0;
      }
       while (!(n === last));
    return consumed;
  }
}
class ASCII extends SingleByteCharset {
  constructor() {
    ASCII_instance = null;
    var tmp = 0;
    var tmp_0 = charArray(128);
    while (tmp < 128) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = numberToChar(tmp_1);
      tmp = tmp + 1 | 0;
    }
    super('ASCII', concatToString(tmp_0) + '\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xF8\xA3\xD8\xD7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\xAE\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\xC1\xC2\xC0\xA9\u2563\u2551\u2557\u255D\xA2\xA5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xE3\xC3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xA4\xF0\xD0\xCA\xCB\xC8\u0131\xCD\xCE\xCF\u2518\u250C\u2588\u2584\xA6\xCC\u2580\xD3\xDF\xD4\xD2\xF5\xD5\xB5\xFE\xDE\xDA\xDB\xD9\xFD\xDD\xAF\xB4\xAD\xB1\u2017\xBE\xB6\xA7\xF7\xB8\xB0\xA8\xB7\xB9\xB3\xB2\u25A0\xA0');
    ASCII_instance = this;
  }
}
class UTC8CharsetBase extends Charset {
  nb4(nbytes) {
    return imul(nbytes, 2);
  }
  ob4(out, src, start, end) {
    if (start < 0 || start > src.length || (end < 0 || end > src.length)) {
      // Inline function 'kotlin.error' call
      var message = 'Out of bounds';
      throw IllegalStateException.o(toString(message));
    }
    var i = start;
    loop: while (i < end) {
      var c = src[i] & 255;
      var tmp4_subject = c >> 4;
      if (0 <= tmp4_subject ? tmp4_subject <= 7 : false) {
        Companion_instance.lb4(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp4_subject ? tmp4_subject <= 13 : false) {
        if ((i + 1 | 0) >= end)
          break loop;
        Companion_instance.lb4(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp4_subject === 14) {
        if ((i + 2 | 0) >= end)
          break loop;
        Companion_instance.lb4(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp4_subject === 15) {
        if ((i + 3 | 0) >= end)
          break loop;
        Companion_instance.lb4(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.o1(_Char___init__impl__6a9atx(65533));
        i = i + 1 | 0;
      }
    }
    return i - start | 0;
  }
}
class WStringReader {
  constructor(str, position) {
    position = position === VOID ? 0 : position;
    this.yb4_1 = str;
    this.zb4_1 = position;
  }
  ab5() {
    return this.yb4_1.a() - this.zb4_1 | 0;
  }
  fb5() {
    return this.zb4_1 >= this.yb4_1.a();
  }
  b6y() {
    return !this.fb5();
  }
  gb5(offset) {
    var tmp0 = this.yb4_1;
    var tmp2 = this.zb4_1 + offset | 0;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.lang.WString.getOrElse' call
      if (tmp2 < 0 || tmp2 >= tmp0.a()) {
        tmp$ret$0 = _WChar___init__impl__4vbl4k(0);
        break $l$block;
      }
      tmp$ret$0 = tmp0.hb5(tmp2);
    }
    return tmp$ret$0;
  }
  ib5(offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.gb5(offset) : $super.gb5.call(this, offset).jb5_1;
  }
  kb5(count) {
    this.zb4_1 = this.zb4_1 + count | 0;
  }
  lb5(offset, len) {
    return substr_1(this.yb4_1, this.zb4_1 + offset | 0, len);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$0 = new Int32Array([]);
    tmp.mb5_1 = new WString(tmp$ret$0, '');
  }
  nb5(codePoints) {
    return this.ob5(codePoints);
  }
  pb5(string) {
    return this.qb5(string);
  }
  qb5(string) {
    if (string === '')
      return this.mb5_1;
    var codePoints = new Int32Array(string.length);
    // Inline function 'korlibs.io.lang.forEachCodePoint' call
    var string_0 = string;
    var m = 0;
    var n = 0;
    while (n < string_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(string_0, _unary__edvuaz);
      var value = Char__toInt_impl_vasixd(this_0);
      var error = false;
      if ((value & 63488) === 55296 && n < string_0.length) {
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_1 = charCodeAt(string_0, _unary__edvuaz_0);
        var extra = Char__toInt_impl_vasixd(this_1);
        if (!((extra & 64512) === 56320)) {
          n = n - 1 | 0;
          error = true;
        } else {
          var dataHigh = value & 1023;
          var dataLow = extra & 1023;
          value = (dataLow | dataHigh << 10) + 65536 | 0;
        }
      }
      var _unary__edvuaz_1 = m;
      m = _unary__edvuaz_1 + 1 | 0;
      codePoints[_unary__edvuaz_1] = value;
    }
    var length = m;
    return new WString(copyOf(codePoints, length), string);
  }
  ob5(codePoints) {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var inductionVariable = 0;
    var last = codePoints.length;
    while (inductionVariable < last) {
      var element = codePoints[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element >= 65536) {
        count = count + 1 | 0;
      }
    }
    var surrogateCount = count;
    var out = StringBuilder.ad(codePoints.length + surrogateCount | 0);
    var inductionVariable_0 = 0;
    var last_0 = codePoints.length;
    while (inductionVariable_0 < last_0) {
      var codePoint = codePoints[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (codePoint > 65535) {
        var U1 = codePoint - 65536 | 0;
        var W1 = 55296 | (U1 >>> 10 | 0) & 1023;
        var W2 = 56320 | (U1 >>> 0 | 0) & 1023;
        out.o1(numberToChar(W1));
        out.o1(numberToChar(W2));
      } else {
        out.o1(numberToChar(codePoint));
      }
    }
    return new WString(codePoints, out.toString());
  }
}
class WString {
  constructor(codePoints, string) {
    Companion_getInstance_0();
    this.bb5_1 = codePoints;
    this.cb5_1 = string;
    this.db5_1 = 0;
    this.eb5_1 = false;
  }
  a() {
    return this.bb5_1.length;
  }
  hb5(index) {
    return _WChar___init__impl__4vbl4k(this.bb5_1[index]);
  }
  qh(startIndex, endIndex) {
    return new WString(copyOfRange_0(this.bb5_1, startIndex, endIndex), substring(this.cb5_1, startIndex, endIndex));
  }
  hashCode() {
    if (!this.eb5_1) {
      this.eb5_1 = true;
      this.db5_1 = contentHashCode(this.bb5_1);
    }
    return this.db5_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof WString) {
      tmp = contentEquals(this.bb5_1, other.bb5_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return this.cb5_1;
  }
}
class INDENTS {
  constructor() {
    INDENTS_instance = this;
    this.rb5_1 = new Object();
    this.sb5_1 = StringBuilder.ad(1024);
    this.tb5_1 = ArrayList.n2(1024);
  }
  u2(index) {
    if (this.tb5_1.s2() <= index) {
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this.rb5_1;
      while (INDENTS_getInstance().tb5_1.s2() <= index) {
        INDENTS_getInstance().tb5_1.d2(INDENTS_getInstance().sb5_1.toString());
        INDENTS_getInstance().sb5_1.o1(_Char___init__impl__6a9atx(9));
      }
    }
    return this.tb5_1.u2(index);
  }
}
class SimpleStrReader {}
function toStringContext() {
  return 'SimpleStrReader(pos=' + this.wb5() + ", peek='" + toString_0(this.ub5()) + "')";
}
class Impl {
  constructor(str, pos) {
    this.xb5_1 = str;
    this.yb5_1 = pos;
  }
  wb5() {
    return this.yb5_1;
  }
  b6y() {
    return this.yb5_1 < this.xb5_1.length;
  }
  vb5() {
    // Inline function 'kotlin.also' call
    var this_0 = new Char(this.ub5());
    this_0.f4_1;
    this.yb5_1 = this.yb5_1 + 1 | 0;
    return this_0.f4_1;
  }
  ub5() {
    var tmp0 = this.xb5_1;
    // Inline function 'kotlin.text.getOrElse' call
    var index = this.yb5_1;
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(tmp0) - 1 | 0) : false) {
      tmp = charSequenceGet(tmp0, index);
    } else {
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
  toString() {
    return "Impl(str='" + this.xb5_1 + "', pos=" + this.yb5_1 + ')';
  }
  zb5() {
    return 'SimpleStrReader(pos=' + this.yb5_1 + ", around='" + substring(this.xb5_1, coerceAtMost(this.yb5_1, this.xb5_1.length), coerceAtMost(this.yb5_1 + 10 | 0, this.xb5_1.length)) + "')";
  }
}
class Companion_1 {
  ab6(str, pos) {
    return new Impl(str, pos);
  }
  bb6(str, pos, $super) {
    pos = pos === VOID ? 0 : pos;
    return $super === VOID ? this.ab6(str, pos) : $super.ab6.call(this, str, pos);
  }
}
//endregion
var CHARSET_PROVIDERS;
var CHARSET_PROVIDERS_LOCK;
function get_UTF8() {
  _init_properties_Charset_kt__c47y1m();
  return UTF8;
}
var UTF8;
function get_LATIN1() {
  _init_properties_Charset_kt__c47y1m();
  return LATIN1;
}
var LATIN1;
var UTF16_LE;
function get_UTF16_BE() {
  _init_properties_Charset_kt__c47y1m();
  return UTF16_BE;
}
var UTF16_BE;
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function toString_1(_this__u8e3s4, charset, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  _init_properties_Charset_kt__c47y1m();
  var out = StringBuilder.ad(charset.nb4(end - start | 0));
  charset.ob4(out, _this__u8e3s4, start, end);
  return out.toString();
}
function readStringz(_this__u8e3s4, o, size, charset) {
  charset = charset === VOID ? get_UTF8() : charset;
  _init_properties_Charset_kt__c47y1m();
  var idx = o;
  var tmp0 = _this__u8e3s4.length;
  // Inline function 'kotlin.math.min' call
  var b = o + size | 0;
  var stop = Math.min(tmp0, b);
  $l$loop: while (idx < stop && _this__u8e3s4[idx] !== 0) {
    idx = idx + 1 | 0;
  }
  return toString_1(copyOfRange(_this__u8e3s4, o, idx), charset);
}
var ISO_8859_1_instance;
function ISO_8859_1_getInstance() {
  if (ISO_8859_1_instance === VOID)
    new ISO_8859_1();
  return ISO_8859_1_instance;
}
var Charsets_instance;
function Charsets_getInstance() {
  return Charsets_instance;
}
var ASCII_instance;
function ASCII_getInstance() {
  if (ASCII_instance === VOID)
    new ASCII();
  return ASCII_instance;
}
var properties_initialized_Charset_kt_dajgec;
function _init_properties_Charset_kt__c47y1m() {
  if (!properties_initialized_Charset_kt_dajgec) {
    properties_initialized_Charset_kt_dajgec = true;
    // Inline function 'kotlin.collections.arrayListOf' call
    CHARSET_PROVIDERS = ArrayList.p2();
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    CHARSET_PROVIDERS_LOCK = get_atomicfu$reentrantLock();
    UTF8 = new UTC8CharsetBase('UTF-8');
    LATIN1 = ISO_8859_1_getInstance();
    UTF16_LE = new UTF16Charset(true);
    UTF16_BE = new UTF16Charset(false);
  }
}
var replaceNonPrintableCharactersRegex$delegate;
function substr(_this__u8e3s4, start) {
  _init_properties_StringExt_kt__eg42u6();
  return substr_0(_this__u8e3s4, start, _this__u8e3s4.length);
}
function substr_0(_this__u8e3s4, start, length) {
  _init_properties_StringExt_kt__eg42u6();
  var low = coerceIn(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
  var high = coerceIn(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
  return high >= low ? substring(_this__u8e3s4, low, high) : '';
}
function substringEquals(_this__u8e3s4, a, aIndex, b, bIndex, count) {
  _init_properties_StringExt_kt__eg42u6();
  if (count === 0)
    return true;
  if (aIndex < 0 || bIndex < 0)
    return false;
  if ((aIndex + count | 0) > a.length)
    return false;
  if ((bIndex + count | 0) > b.length)
    return false;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charCodeAt(a, aIndex + n | 0) === charCodeAt(b, bIndex + n | 0)))
        return false;
    }
     while (inductionVariable < count);
  return true;
}
function withInsertion(_this__u8e3s4, index, insertedText) {
  _init_properties_StringExt_kt__eg42u6();
  var before = substr_0(_this__u8e3s4, 0, index);
  var after = substr_0(_this__u8e3s4, index, _this__u8e3s4.length);
  return before + insertedText + after;
}
function withoutRange(_this__u8e3s4, range) {
  _init_properties_StringExt_kt__eg42u6();
  return substr_0(_this__u8e3s4, 0, range.n3_1) + substr(_this__u8e3s4, range.o3_1 + 1 | 0);
}
function withoutIndex(_this__u8e3s4, index) {
  _init_properties_StringExt_kt__eg42u6();
  return substr_0(_this__u8e3s4, 0, index) + substr(_this__u8e3s4, index + 1 | 0);
}
function replaceNonPrintableCharactersRegex$delegate$lambda() {
  _init_properties_StringExt_kt__eg42u6();
  return Regex.hi('[^ -~]');
}
var properties_initialized_StringExt_kt_sd962o;
function _init_properties_StringExt_kt__eg42u6() {
  if (!properties_initialized_StringExt_kt_sd962o) {
    properties_initialized_StringExt_kt_sd962o = true;
    replaceNonPrintableCharactersRegex$delegate = lazy(replaceNonPrintableCharactersRegex$delegate$lambda);
  }
}
function _WChar___init__impl__4vbl4k(codePoint) {
  return codePoint;
}
function _WChar___get_codePoint__impl__c8brwu($this) {
  return $this;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function substr_1(_this__u8e3s4, start, length) {
  length = length === VOID ? _this__u8e3s4.a() : length;
  var low = coerceIn(start >= 0 ? start : _this__u8e3s4.a() + start | 0, 0, _this__u8e3s4.a());
  var high = coerceIn(length >= 0 ? low + length | 0 : _this__u8e3s4.a() + length | 0, 0, _this__u8e3s4.a());
  return high < low ? Companion_getInstance_0().pb5('') : _this__u8e3s4.qh(low, high);
}
function extract(_this__u8e3s4, offset, count) {
  return (_this__u8e3s4 >>> offset | 0) & mask(count);
}
function getS16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS16LE(_this__u8e3s4, offset) : getS16BE(_this__u8e3s4, offset);
}
function insert(_this__u8e3s4, value, offset, count) {
  var mask_0 = mask(count) << offset;
  var ovalue = value << offset & mask_0;
  return _this__u8e3s4 & ~mask_0 | ovalue;
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function getS16LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16LE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS16BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16BE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 1 | 0) << 0 | u8(_this__u8e3s4, offset + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function u8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function isWhitespaceFast(_this__u8e3s4) {
  return _this__u8e3s4 === _Char___init__impl__6a9atx(32) || _this__u8e3s4 === _Char___init__impl__6a9atx(9) || _this__u8e3s4 === _Char___init__impl__6a9atx(13) || _this__u8e3s4 === _Char___init__impl__6a9atx(10);
}
function isDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function isLetterOrDigit(_this__u8e3s4) {
  return isLetter(_this__u8e3s4) || isDigit(_this__u8e3s4);
}
function isLetterDigitOrUnderscore(_this__u8e3s4) {
  return isLetterOrDigit(_this__u8e3s4) || _this__u8e3s4 === _Char___init__impl__6a9atx(95) || _this__u8e3s4 === _Char___init__impl__6a9atx(36);
}
function isLetter(_this__u8e3s4) {
  return (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false);
}
function unquote(_this__u8e3s4) {
  return isQuoted(_this__u8e3s4) ? unescape(substring(_this__u8e3s4, 1, _this__u8e3s4.length - 1 | 0)) : _this__u8e3s4;
}
function isQuoted(_this__u8e3s4) {
  return startsWith(_this__u8e3s4, _Char___init__impl__6a9atx(34)) && endsWith(_this__u8e3s4, _Char___init__impl__6a9atx(34));
}
function unescape(_this__u8e3s4) {
  var out = StringBuilder.ad(_this__u8e3s4.length);
  var n = 0;
  while (n < _this__u8e3s4.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var c = charCodeAt(_this__u8e3s4, _unary__edvuaz);
    if (c === _Char___init__impl__6a9atx(92)) {
      var _unary__edvuaz_0 = n;
      n = _unary__edvuaz_0 + 1 | 0;
      var c2 = charCodeAt(_this__u8e3s4, _unary__edvuaz_0);
      if (c2 === _Char___init__impl__6a9atx(92))
        out.o1(_Char___init__impl__6a9atx(92));
      else if (c2 === _Char___init__impl__6a9atx(34))
        out.o1(_Char___init__impl__6a9atx(34));
      else if (c2 === _Char___init__impl__6a9atx(110))
        out.o1(_Char___init__impl__6a9atx(10));
      else if (c2 === _Char___init__impl__6a9atx(114))
        out.o1(_Char___init__impl__6a9atx(13));
      else if (c2 === _Char___init__impl__6a9atx(116))
        out.o1(_Char___init__impl__6a9atx(9));
      else if (c2 === _Char___init__impl__6a9atx(120) || c2 === _Char___init__impl__6a9atx(117)) {
        var N = c2 === _Char___init__impl__6a9atx(117) ? 4 : 2;
        var chars = substring(_this__u8e3s4, n, n + N | 0);
        n = n + N | 0;
        out.o1(numberToChar(toInt(chars, 16)));
      } else {
        out.m1('\\' + toString_0(c2));
      }
    } else
      out.o1(c);
  }
  return out.toString();
}
function substringAfterOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringAfter(_this__u8e3s4, delimiter) : null;
}
function substringBeforeOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringBefore(_this__u8e3s4, delimiter) : null;
}
var INDENTS_instance;
function INDENTS_getInstance() {
  if (INDENTS_instance === VOID)
    new INDENTS();
  return INDENTS_instance;
}
function skipWhile(_this__u8e3s4, cond) {
  while (_this__u8e3s4.b6y()) {
    var c = _this__u8e3s4.ub5();
    if (!cond(new Char(c))) {
      return _this__u8e3s4;
    }
    _this__u8e3s4.vb5();
  }
  return _this__u8e3s4;
}
function get_eof(_this__u8e3s4) {
  return !_this__u8e3s4.b6y();
}
function skipSpaces(_this__u8e3s4) {
  skipWhile(_this__u8e3s4, skipSpaces$lambda);
  return _this__u8e3s4;
}
function skipExpect(_this__u8e3s4, expected) {
  var readed = _this__u8e3s4.vb5();
  if (!(readed === expected)) {
    throw IllegalArgumentException.h2("Expected '" + toString_0(expected) + "' but found '" + toString_0(readed) + "' at " + _this__u8e3s4.wb5());
  }
}
function readUntilBuilder(_this__u8e3s4, char, out, included) {
  included = included === VOID ? false : included;
  // Inline function 'korlibs.util.readUntilBuilder' call
  $l$loop: while (_this__u8e3s4.b6y()) {
    var c = _this__u8e3s4.ub5();
    if (c === char) {
      if (included) {
        _this__u8e3s4.vb5();
        out.o1(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.vb5();
    out.o1(c);
  }
  return out;
}
function matchSingleOrDoubleQuoteString(_this__u8e3s4, out) {
  var tmp12_subject = _this__u8e3s4.ub5();
  var tmp;
  if (tmp12_subject === _Char___init__impl__6a9atx(39) || tmp12_subject === _Char___init__impl__6a9atx(34)) {
    var quoteType = _this__u8e3s4.vb5();
    out.o1(quoteType);
    tmp = readUntilBuilder(_this__u8e3s4, quoteType, out, true);
  } else {
    tmp = null;
  }
  return tmp;
}
function matchIdentifier(_this__u8e3s4, out) {
  // Inline function 'korlibs.util.readWhileBuilder' call
  // Inline function 'korlibs.util.readUntilBuilder' call
  $l$loop: while (_this__u8e3s4.b6y()) {
    var c = _this__u8e3s4.ub5();
    if (!(isLetterDigitOrUnderscore(c) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(126) || c === _Char___init__impl__6a9atx(58))) {
      if (false) {
        _this__u8e3s4.vb5();
        out.o1(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.vb5();
    out.o1(c);
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(out) > 0) {
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function tryExpect(_this__u8e3s4, char, consume) {
  consume = consume === VOID ? true : consume;
  var read = _this__u8e3s4.ub5();
  var isExpected = read === char;
  if (consume && isExpected) {
    _this__u8e3s4.vb5();
  }
  return isExpected;
}
function skipSpaces$lambda(it) {
  return isWhitespaceFast(it.f4_1);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Charset, 'Charset');
initMetadataForClass(BaseSingleByteCharset, 'BaseSingleByteCharset');
initMetadataForClass(SingleByteCharset, 'SingleByteCharset');
initMetadataForObject(ISO_8859_1, 'ISO_8859_1');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForClass(UTF16Charset, 'UTF16Charset');
initMetadataForObject(ASCII, 'ASCII');
initMetadataForClass(UTC8CharsetBase, 'UTC8CharsetBase');
initMetadataForClass(WStringReader, 'WStringReader');
initMetadataForCompanion(Companion_0);
initMetadataForClass(WString, 'WString');
initMetadataForObject(INDENTS, 'INDENTS');
initMetadataForInterface(SimpleStrReader, 'SimpleStrReader');
initMetadataForClass(Impl, 'Impl', VOID, VOID, [SimpleStrReader]);
initMetadataForCompanion(Companion_1);
//endregion
//region block: init
Companion_instance = new Companion();
Charsets_instance = new Charsets();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  _WChar___get_codePoint__impl__c8brwu as _WChar___get_codePoint__impl__c8brwusjw60nkqwcvk,
  ASCII_getInstance as ASCII_getInstance1ki74j81tlqzy,
  Charsets_instance as Charsets_instance36f67kdzeu1kr,
  Companion_getInstance_0 as Companion_getInstance2omq1gulueyfd,
  INDENTS_getInstance as INDENTS_getInstance100uyhd8ddvwu,
  Companion_instance_1 as Companion_instance5ppff3ldz8y,
  get_UTF16_BE as get_UTF16_BE3rxrt7v8707y4,
  get_UTF8 as get_UTF82geyfhi1l22xl,
  WStringReader as WStringReader2bukzqxb5clbi,
  WString as WStringambx64bqrrmq,
  readStringz as readStringzinkjpjt71hyo,
  substringEquals as substringEqualse7vi4930fev5,
  substr_0 as substr1q77u5lo4evr6,
  substr as substr2jonrcqd8qwvx,
  toString_1 as toString2x583ovdqfjci,
  withInsertion as withInsertion32qy0wb7w2f46,
  withoutIndex as withoutIndex1982826lx7knb,
  withoutRange as withoutRangetvtevgxw4fe7,
  isWhitespaceFast as isWhitespaceFast2iszcfvpi3biz,
  substringAfterOrNull as substringAfterOrNull6pqoc8ojvu1x,
  substringBeforeOrNull as substringBeforeOrNullyyd9hl5du3pj,
  unquote as unquote1kjyk5vajgaow,
  toStringContext as toStringContext20qw1vqodfj0k,
  SimpleStrReader as SimpleStrReader35udnj8g5ojo6,
  get_eof as get_eofrk1bzx8ckgtd,
  matchIdentifier as matchIdentifier3b7zgfy94bf8r,
  matchSingleOrDoubleQuoteString as matchSingleOrDoubleQuoteString398sq4vhn9fz,
  readUntilBuilder as readUntilBuilderazvgts3bogti,
  skipExpect as skipExpect1tagjz9aj6y5q,
  skipSpaces as skipSpaces25iogcdi8m3q2,
  tryExpect as tryExpect2a3h5rf36r8u1,
};
//endregion
